import {
  AddFavouriteUploadParams,
  FavouriteUrl,
} from "core/types/favourite-url.types";
import { ApiFactoryClients } from "../api.types";
import { transformFavouriteUrlList } from "./favourite-url.helpers";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  addFavourite: ({
    searchId,
    description,
    thumbnailUrl,
    title,
    url,
  }: AddFavouriteUploadParams) =>
    codeHttpClient.post("/reports", {
      search_id: searchId,
      description: description,
      thumbnail_url: thumbnailUrl,
      title: title,
      url: url,
    }),
  getList: (): Promise<FavouriteUrl[]> =>
    codeHttpClient
      .get("/reports")
      .then((data) => transformFavouriteUrlList(data)),
  delete: (id: number) => codeHttpClient.delete("/reports?url_id=" + id),
});
